import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EFDataService, EFProduct, EFSupplier } from 'pg-lib';

@Component({
    selector: 'app-ef-product-view',
    templateUrl: './ef-product-view.component.html',
    styleUrls: ['./ef-product-view.component.scss'],
    standalone: false
})
export class EfProductViewComponent implements OnInit {

    isLoading = false;

    appMode = 'web';

    productData:EFProduct = null;
    supplierData:EFSupplier = null;
    
    resourceId:string = null;
    elementId:string = null;

    constructor(private dataService:EFDataService, private route:ActivatedRoute, private router:Router) { }

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.isLoading = true;

            this.resourceId = params.resource;
            this.elementId = params.id;

            this.productData = null;
            this.supplierData = null;

            this.dataService.getResourceProduct(this.resourceId, this.elementId).subscribe((data) => {
                this.productData = data;

                if(data.supplier != null) {
                    this.dataService.getResourceSupplier(data.supplier.split('_')[0], data.supplier.split('_')[1]).subscribe((data) => {
                        this.supplierData = data;
                        this.isLoading = false;
                    })
                }
                else {
                    this.isLoading = false;
                }
            })
        })
    }

    canGoBackToSupplier() {
        return this.productData?.type == 'good' && this.productData?.supplier != null;
    }

    onGoBack() {
        if(!this.canGoBackToSupplier()) return;

        let _separator = this.productData.supplier.indexOf('_');
        if(_separator != -1) {
            let _resource = this.dataService.normalizeResourceName(this.productData.supplier.substring(0, _separator));
            let _id = this.productData.supplier.substring(_separator + 1);
            this.router.navigate(['/product', _resource, _id]);
        }
    }

    onShowProduct(product:string) {
        let _separator = product.indexOf('_');
        if(_separator != -1) {
            this.router.navigate(['/product', product.substring(0, _separator), product.substring(_separator + 1)]);
        }
    }
}
